import { ITransactionSummary } from '@/types/models';
import {
  getTransactionType,
  getStatus
} from '@/modules/transaction/views/TransactionsLegacy/helpers/transaction';
import { formatCurrency } from '@/modules/common/helpers/currency';

export const parseTransaction = (transaction: any): ITransactionSummary => {
  return {
    id: transaction._id,
    type: {
      value: transaction.type
    },
    date: transaction.operatedAt || transaction.createdAt,
    description: getTransactionType(transaction.type),
    status: {
      value: transaction.status,
      formatted: getStatus(transaction.status)
    },
    amount: {
      formatted: `R$ ${formatCurrency(transaction.amount)}`
    }
  };
};
